<script setup lang="ts">
import {useCdnUrl} from '@/composables/cdn-url';
const {getYear} = useUtils();
</script>

<template>
  <footer class="bg-black py-[8rem] px-[8rem] flex flex-col gap-[5rem]">
    <LazyTheCountdown />

    <div class="footer-content w-full flex content-between text-white mx-auto max-w-[2560px] p-[4rem]">
      <div class="flex flex-col flex-1 footer-logos gap-[1rem] items-start text-[1.25rem]">
        <TheNuxtLink to="https://www.jamestownlp.com/" target="_blank" aria-label="Go to Jamestown LP website" analytics-target="jamestown-website">
          <nuxt-img :src="`${useCdnUrl()}/assets/logos/jamestown-logo.svg`" class="w-auto h-[75px]" alt="Jamestown LP" />
        </TheNuxtLink>
        <p class="m-0 text-[1.25rem]" v-html="$t('footer.jamestown_subtitle')"></p>
      </div>

      <div class="footer-connect text-center content-center items-center flex flex-col flex-1 gap-4 text-[1.6rem]">
        <TheSocialMenu />
      </div>

      <div class="flex flex-1 gap-[10rem] text-[1.25rem] content-end align-end">
        <div class="ml-auto flex flex-col gap-[2rem]">
          <div class="text-[2rem] font-bold uppercase text-gray-500">{{ $t('footer.experiences.experiences') }}</div>

          <ul class="flex flex-col gap-[.5rem]">
            <li>
              <NuxtLink to="https://www.icandynyc.com" target="_blank">iCandy</NuxtLink>
            </li>
            <li>
              <NuxtLink to="/nye-ball-crystal-vip-experience" class="text-[1.8rem] hover:underline">NYE Ball and Crystal VIP Experience</NuxtLink>
            </li>
            <li>
              <NuxtLink to="/#times-travel">{{ $t('footer.experiences.times_travel') }}</NuxtLink>
            </li>
            <!-- <li>
              <NuxtLink to="#" class="cursor-not-allowed">{{ $t('footer.experiences.next_gen') }}</NuxtLink>
            </li> -->
            <li>
              <NuxtLink to="/#ever">{{ $t('footer.experiences.ever') }}</NuxtLink>
            </li>

            <!-- <li>
              <NuxtLink to="#" class="cursor-not-allowed">{{ $t('footer.experiences.new_years_eve') }}</NuxtLink>
            </li>
            <li>
              <NuxtLink to="#" class="cursor-not-allowed">{{ $t('footer.experiences.past_experiences') }}</NuxtLink>
            </li> -->
          </ul>
        </div>

        <div class="flex flex-col gap-[2rem]">
          <div class="text-[2rem] font-bold uppercase text-gray-500">{{ $t('footer.society.society') }}</div>
          <ul class="flex flex-col gap-[.5rem]">
            <!-- <li>
              <NuxtLink to="#" class="cursor-not-allowed">{{ $t('footer.society.about_us') }}</NuxtLink>
            </li>
            <li>
              <NuxtLink to="#" class="cursor-not-allowed">{{ $t('footer.society.careers') }}</NuxtLink>
            </li> -->
            <li>
              <NuxtLink to="/bathrooms">{{ $t('footer.experiences.bathrooms') }}</NuxtLink>
            </li>
            <li>
              <NuxtLink to="/faqs">{{ $t('footer.society.faqs') }}</NuxtLink>
            </li>
            <!-- <li>
              <NuxtLink to="#" class="cursor-not-allowed">{{ $t('footer.society.teams') }}</NuxtLink>
            </li> -->
          </ul>
        </div>
      </div>
    </div>

    <div class="privacy flex flex-col text-[1.25rem] w-full text-center text-gray-500">
      <div>
        &copy;{{ getYear() }} {{ $t('footer.all_rights_reserved') }} Jamestown L.P.
        <TheNuxtLink to="/privacy-policy" class="text-gray-600 underline visited:text-gray-500" aria-label="Privacy Policy">{{ $t('footer.privacy_policy') }}</TheNuxtLink>
      </div>
    </div>
  </footer>
</template>

<style lang="scss">
@use '@/assets/scss/queries';
footer {
  .footer-content {
    @media (max-width: 820px) {
      padding: 0 0rem 3rem 0rem;
    }

    @include queries.for-size(tablet-landscape-down) {
      flex-direction: column;
      font-size: 2rem;
      gap: 2rem;
      div {
        display: flex;

        flex-direction: column !important;
        text-align: center;
        width: 100%;
      }

      .footer-connect {
        font-size: 2rem !important;
      }
    }

    .content-end {
      @include queries.for-size(phone-only) {
        gap: 2em;
        padding-top: 3rem;

        > div {
          gap: 1rem;
        }
      }

      ul {
        li {
          a {
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }

    .footer-logos {
      @include queries.for-size(phone-only) {
        justify-content: center;
        padding: 3rem;
        width: 100%;
      }
    }
  }
}
</style>
